import { RootState } from '../../index';

export const getDemoColors = (state: RootState) => state.themes.demoColors;
